/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Content_Responsible_AddressInputs */

const en_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const de_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const fr_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const es_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const it_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const nl_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const pl_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const fi_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const da_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

const sv_impressum_content_responsible_address = /** @type {(inputs: Impressum_Content_Responsible_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppoldstr. 1, 86551 Aichach`)
};

/**
* | output |
* | --- |
* | "Koppoldstr. 1, 86551 Aichach" |
*
* @param {Impressum_Content_Responsible_AddressInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_content_responsible_address = /** @type {((inputs?: Impressum_Content_Responsible_AddressInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Content_Responsible_AddressInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_content_responsible_address(inputs)
	if (locale === "fr") return fr_impressum_content_responsible_address(inputs)
	if (locale === "es") return es_impressum_content_responsible_address(inputs)
	if (locale === "it") return it_impressum_content_responsible_address(inputs)
	if (locale === "nl") return nl_impressum_content_responsible_address(inputs)
	if (locale === "pl") return pl_impressum_content_responsible_address(inputs)
	if (locale === "fi") return fi_impressum_content_responsible_address(inputs)
	if (locale === "da") return da_impressum_content_responsible_address(inputs)
	if (locale === "sv") return sv_impressum_content_responsible_address(inputs)
	return en_impressum_content_responsible_address(inputs)
});